import {gql} from '@apollo/client/core';

const hotels = gql`
    query hotels($serviceCountry: ServiceCountryEnum!, $filter: HotelFilterInputType) {
        hotels(serviceCountry: $serviceCountry, filter: $filter) {
            id
            udprn
            name
            address
            lat
            lng
            image_urls
            pickupType
        }
    }
`;

export {hotels};
